

import CryptoJS from "crypto-js";
// import axios from "axios";

const ivr = process.env.REACT_APP_IV;
const keyr = process.env.REACT_APP_KEY;

const ivr2 = process.env.REACT_APP_IV2;
const keyr2 = process.env.REACT_APP_KEY2;


function asciiTOHexa(str) {
  const arr1 = [];
  for (let n = 0; n < str.length; n += 1) {
    const hex = Number(str.charCodeAt(n)).toString(16);
    arr1.push(hex);
  }
  return arr1.join("");
}

const ivt2 = asciiTOHexa(ivr2);
const keyt2 = asciiTOHexa(keyr2);

const ivt = asciiTOHexa(ivr);
const keyt = asciiTOHexa(keyr);

const key = CryptoJS.enc.Hex.parse(keyt);
const iv = CryptoJS.enc.Hex.parse(ivt);

const key2 = CryptoJS.enc.Hex.parse(keyt2);
const iv2 = CryptoJS.enc.Hex.parse(ivt2);

// const sendOTP = async (bvn) => {
//     try {
//       const response = await axios.post(
//         "https://providusonline.providusbank.com:8443/api/account/otp/sendToken",
//         {
//           bvn,
//         }
//       );

   
//       let OTPDetails = response.data;
//       localStorage.setItem("accountOpeningUserCode", OTPDetails.userCode);
//       return response.data;
//     } catch (er) {
   
//       return null;
//     }
//   };

//   const verifyToken = async (token) => {
//     if (token === null || token == "") {
//       setOTPError("Token is empty");
//       return;
//     }

//     setOTPSubmitting(true);
//     try {
//       const response = await axios.post(
//         "https://providusonline.providusbank.com:8443/api/account/otp/verifyToken",
//         {
//           token,
//           usercode: localStorage.getItem("accountOpeningUserCode"),
//         }
//       );
//       let resp = response.data;
   
//       if (resp.code == "00") {
//         setShowOTP(false);
//         bottomRef.current.scrollIntoView({ behavior: "smooth" });
//         onSubmit();
//         // if(bottomRef.current!=null){

//         //}
//       } else {
//         setOTPError(resp.message && "OTP verification failed, kindly retry.");
//       }
//     } catch (er) {
    
//       setOTPError("OTP verification failed, kindly retry.");
//     }
//     setOTPSubmitting(false);
//     // return response.data;
//   };


  


export const Encrypt = async (str) => {
  try {
    const encryptedRequest = await CryptoJS.AES.encrypt(
      JSON.stringify(str),
      key,
      {
        iv,
      }
    ).ciphertext.toString(CryptoJS.enc.Hex);

    return encryptedRequest;
  } catch (er) {
    console.log(er);
    return null;
  }
};

// export const Decrypt = async (encryptedData) => {
//   const response = await CryptoJS.AES.decrypt(encryptedData, key, {
//     iv,
//     format: CryptoJS.format.Hex,
//   }).toString(CryptoJS.enc.Utf8);

//   return response;
// };

export const Decrypt = async (encryptedData) => {
  let response=null;
  try{
  response = await CryptoJS.AES.decrypt(encryptedData, key, {
    iv,
    format: CryptoJS.format.Hex,
  }).toString(CryptoJS.enc.Utf8);
  }catch(er){
    response = await CryptoJS.AES.decrypt(encryptedData, key2, {
      iv2,
      format: CryptoJS.format.Hex,
    }).toString(CryptoJS.enc.Utf8);
  }
  return response;
};


